// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/spulenkoerper/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSpulenkoerperDE: PageEntry = {
  id: "example.produkte-spulenkoerper",
  locale: "de",
  slug: "produkte/spulenkoerper",
  seo: {
    title: "Spulenkörper | Dietz GmbH",
    description: "Hybridteil zur weiteren Verarbeitung zur Aufnahme verschiedener Kupferspulen. Vollautomatischer Montageprozess in einem Bihler Stanzautomat. Montage von einem Blech mit integrierte",
  },
  type: "post",
  h1: "Spulenkörper",
  intro: "Hybridteil zur weiteren Verarbeitung zur Aufnahme verschiedener Kupferspulen. Vollautomatischer Montageprozess in einem Bihler Stanzautomat. Montage von einem Blech mit integrierter Verschraubung mit anschließendem Fügen in das Kunststoffteil",
  blocks: [
    { kind: "image", src: "/images/live/DTZ-spulenkoerper.jpg", alt: "Spulenkörper", width: 1400, height: 1120 }
  ],
};
